export const cilEuro = ["24 24","<path d='M14.813 5.625h2.813v-1.5h-2.813c-3.457 0-6.412 2.187-7.556 5.25h-2.381v1.5h1.982c-0.068 0.395-0.107 0.849-0.107 1.313s0.039 0.918 0.114 1.36l-0.007-0.048h-1.982v1.5h2.381c1.144 3.063 4.099 5.25 7.556 5.25h2.813v-1.5h-2.813c-2.601-0.002-4.849-1.516-5.911-3.711l-0.017-0.039h7.241v-1.5h-7.743c-0.084-0.395-0.132-0.848-0.132-1.313s0.048-0.918 0.139-1.355l-0.007 0.043h7.743v-1.5h-7.241c1.080-2.234 3.327-3.748 5.928-3.75h0z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-euro.js
// module id = null
// module chunks = 